import {
  Checkbox,
  FormControlLabel,
  Radio,
  RadioGroup,
  Button,
  CircularProgress,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";

import { red } from "@mui/material/colors";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import ReCAPTCHA from "react-google-recaptcha";
import * as Yup from "yup";
import ErrorText from "../common/ErrorText";
import { useEffect } from "react";
import { useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import styles from "../../Styles/modal.module.css";
import { useFormik } from "formik";
import apiCall from "../../helpers/apifactory";
import Select from "react-select";
import ServiceAgreementForm from "./TermsAndCond";
import Undertaking from "./RegUndertaking";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const TcsEcom = () => {
  const modalRef = useRef(null);
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [cities, setCities] = useState([]);
  const [area, setArea] = useState([]);
  const [clickCount, setClickCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const successModalRef = useRef(null);
  const errorModalRef = useRef(null);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showUndertakingModal, setShowUndertakingModal] = useState(false);
  const [isCitiesLoading, setIsCitiesLoading] = useState(true);
  const [isAreaLoading, setIsAreaLoading] = useState(false);

  const [openTariffModal, setOpenTariffModal] = useState(false);
  const [nextEnabled, setNextEnabled] = useState(false);

  const salesTaxOptions = [
    { value: "non-registered", label: "Non-Registered" },
    { value: "registered", label: "Registered" },
  ];

  const categoryOptions = [
    { value: "Sole Proprietorship", label: "Sole Proprietorship" },
    { value: "Partnership", label: "Partnership" },
    { value: "Private Limited", label: "Private Limited" },
    {
      value: "Limited Liability Corporation",
      label: "Limited Liability Corporation",
    },
  ];
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const [nicFrontError, setNicFrontError] = useState("");
  const [nicBackError, setNicBackError] = useState("");

  const formik = useFormik({
    validateOnMount: true,
    validateOnChange: true,
    initialValues: {
      bussinessType: "yes",
      bussinessType2: "",
      compAccTitle: "",
      ownerName: "",
      cnic: "",
      ntn: "",
      city: undefined,
      location: "",
      pickAddress: "",
      compNum: "",
      mobNum: "",
      mobNum2: "",
      compEmail: "",

      website: false,
      instagram: false,
      other: false,
      bussinessName: "",
      billAddress: "",
      salesTax: "",
      monthsInBussiness: "",
      avgShip: "",
      PhoneNo: "",
      name: "",
      designation: "",
      custMobNum: "",
      custEmail: "",
      custCNIC: "",
      nicfront: "",
      nicback: "",
      prodRange: {},
      termCond: false,
      undertak: false,
      recaptcha: "",
      strn: "",
      categories: "",
    },
    validationSchema: Yup.object({
      compAccTitle: Yup.string().required("This is Required"),

      area: Yup.object(),
      categories: Yup.string().required("This is Required"),

      bussinessType2: Yup.string(),
      ownerName: Yup.string().required("This is Required"),
      cnic: Yup.string()
        .test(
          "cnic-required",
          "This is Required",
          (value) => value && value.length === 15,
        )
        .matches(/^\d{5}-\d{7}-\d{1}$/, "Format should be xxxxx-xxxxxxx-x"),

      ntn: Yup.string()
        .matches(/^[a-zA-Z0-9]{7}-[a-zA-Z0-9]{1}$/, {
          message: "NTN must be in xxxxxxx-x format",
          excludeEmptyString: false,
        })
        .required("This is Required"),

      // ntn: Yup.string().when("salesTax", {
      //   is: "registered",
      //   then: (schema) =>
      //     schema
      //       .required("This is Required")
      //       .matches(
      //         /^[a-zA-Z0-9]{7}-[a-zA-Z0-9]{1}$/,
      //         "NTN must be in xxxxxxx-x format"
      //       ),
      //   otherwise: (schema) => schema.notRequired().nullable(),
      // }),

      city: Yup.object()?.required("This is Required"),
      pickAddress: Yup.string().required("This is Required"),
      compNum: Yup.string(),
      recaptcha: Yup.string().required("Please accept"),
      mobNum: Yup.string()
        .matches(/^((\+92)?(0092)?(92)?(0)?)(3)([0-9]{9})$/gm, {
          message: "Invalid phone number",
          excludeEmptyString: false,
        })
        .required("This is Required"),
      mobNum2: Yup.string()
        .nullable()
        .notRequired()
        .test("is-valid-or-empty", "Invalid phone number", (value) => {
          return (
            !value ||
            value === "" ||
            /^((\+92)?(0092)?(92)?(0)?)(3)([0-9]{9})$/.test(value)
          );
        }),
      compEmail: Yup.string()
        .email("Invalid email address")
        .required("This is Required"),

      billAddress: Yup.string().required("This is Required"),
      salesTax: Yup.string(),
      PhoneNo: Yup.string().matches(
        /^((\+92)?(0092)?(92)?(0)?)(3)([0-9]{9})$/gm,
        {
          message: "Invalid phone number",
          excludeEmptyString: false,
        },
      ),
      designation: Yup.string().required("This is Required"),
      prodRange: Yup.object().required("This is Required"),

      termCond: Yup.boolean()
        .required("Terms and conditions must be accepted.")
        .oneOf([true], "Terms and conditions must be accepted."),
      undertak: Yup.boolean()
        .required("Undertakings must be accepted.")
        .oneOf([true], "Undertakings must be accepted."),
      strn: Yup.string().matches(
        /^[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{3}-[a-zA-Z0-9]{2}$/,
        "STRN must be in xx-xx-xxxx-xxx-xx format",
      ),
    }),
    onSubmit: async (values) => {
      setIsLoading(true);
      let cnicFrontBase64 = "";
      let cnicBackBase64 = "";

      if (values.nicfront) {
        cnicFrontBase64 = await convertToBase64(values.nicfront);
      }

      if (values.nicback) {
        cnicBackBase64 = await convertToBase64(values.nicback);
      }
      const ecomdbBody = {
        companyname: values?.compAccTitle,
        ownername: values?.ownerName,
        cnicnumber: values?.cnic,
        ntnnumber: values?.ntn,
        strnnumber: values?.strn,
        origincity: values?.city?.value,
        area: values?.area?.value,
        categories: values?.categories,
        pickupaddress: values?.pickAddress,
        companynumber: values?.compNum,
        mobilenumber: values?.mobNum,
        mobilenumber2: values?.mobNum2,
        companyemail: values?.compEmail,
        businessname: values?.bussinessName,
        billingaddress: values?.billAddress,
        salestax: values?.salesTax,
        phonenumber: values?.PhoneNo,
        name: values?.ownerName,
        designation: values?.designation,
        customermobilenumber: values?.mobNum,
        customeremail: values?.compEmail,
        customercnic: values?.cnic,
        socialfacebook: !!values?.facebook,
        socialwhatsapp: !!values?.whatsapp,
        socialwebsite: !!values?.website,
        socialinstagram: !!values?.instagram,
        ibannumber: values?.iban,
        bankname: values?.bankName,
        branch: values?.branch,
        bankaccounttitle: values?.bankAcTitle,
        createdon: new Date().toISOString(),

        nicback: cnicBackBase64,
        nicfront: cnicFrontBase64,
      };

      const body = {
        toEmailID: "NewAccountOpening@tcs.com.pk",
        // toEmailID: "muhammad.usama@tcs.com.pk",
        fromEmailID: "noreply@tcs.com.pk",
        emailSubject: values?.compEmail,
        emailText: `
            CompanyName: ${values?.compAccTitle} <br />
            OwnerName: ${values?.ownerName} <br />
            CNICNumber: ${values?.cnic} <br />
            NtnNumber: ${values?.ntn} <br />
            STRNNumber: ${values?.strn} <br />
            OriginCity: ${values?.city?.value} <br />
            Area: ${values?.area?.value} <br />
            Categories: ${values?.categories} <br />
            BussinessType2: ${values?.bussinessType2} <br />
            PickUpAddress: ${values?.pickAddress} <br />
            companyNumber: ${values?.compNum} <br />
            MobileNumber: ${values?.mobNum} <br />
            MobileNumber2: ${values?.mobNum2} <br />
            CompanyEmail: ${values?.compEmail} <br />
            Facebook: ${values?.facebook} <br />
            Whatsapp: ${values?.whatsapp} <br />
            Website: ${values?.website} <br />
            Instagram: ${values?.instagram} <br />
            Other: ${values?.other} <br />
            BussinessName: ${values?.bussinessName} <br />
            BillingAddress: ${values?.billAddress} <br />
            SalesTax: ${values?.salesTax} <br />
            PhoneNumber: ${values?.PhoneNo} <br />
            Name: ${values?.ownerName} <br />
            Designation: ${values?.designation} <br />
            customerMobileNumber: ${values?.mobNum} <br />
            CustomerEmail: ${values?.compEmail} <br />
            CustomerCNIC: ${values?.cnic} <br />
            Term&Condition: ${values?.termCond} <br />
            UnderTaking: ${values?.undertak} <br />
            IbanNumber: ${values?.iban} <br />
            BankName: ${values?.bankName} <br />
            Branch: ${values?.branch} <br />
            BankAccountTitle: ${values?.bankAcTitle} <br />

            `,
        cc: values?.custEmail,
        bcc: values?.custEmail,
        attachments: [],
        replyTo: values?.custEmail,
      };

      const bodycustomer = {
        toEmailID: values?.compEmail,
        fromEmailID: "noreply@tcs.com.pk",
        emailSubject:
          "Thank You for Choosing TCS! COD Account Opening Request Received.",
        emailText: `Dear ${values?.ownerName}, <br />
        Thank you for reaching out to us. This is an automated response to confirm that we have received your data for COD Account Opening. Your request is important to us, and we appreciate the trust you have placed in our services.
        Our team is diligently reviewing the information you provided. Please allow us 24-48 hours to carefully assess your data and address your inquiry thoroughly.
        Thank you once again for choosing our services. We look forward to working with you.
        Warm regards,
        TCS Ecom Solutions Team.
        `,

        cc: "",
        bcc: "",
        attachments: [],
      };

      // Helper function to check if the ecom lead response is successful
      const isEcomLeadSuccess = (protocol) => {
        if (!protocol?.isSuccess) return false;
        const code = protocol?.responseData?.code;
        const message = protocol?.responseData?.message?.toLowerCase();
        return code === "200" || message === "success";
      };

      // Helper function to send emails after successful lead creation
      const sendEmails = () => {
        apiCall
          .sendEmail(body, {})
          .then((res) => {
            formik.setValues(formik?.initialValues);
            formik.setTouched({}, false);
            apiCall
              .sendEmail(bodycustomer, {})
              .then((res) => {
                formik.setValues(formik?.initialValues);
                formik.setTouched({}, false);
                setShow(true);
                formik?.setFieldValue("area", "");
                formik?.setFieldValue("city", "");
                setClickCount(0);
              })
              .catch((err) => {
                console.log("Customer Email error:", err);
                setShowError(true);
              })
              .finally(() => {
                setIsLoading(false);
              });
          })
          .catch((err) => {
            console.log("Email error:", err);
            setShowError(true);
            setIsLoading(false);
          });
      };

      // Retry mechanism for createecomlead API
      const MAX_RETRIES = 3;
      const RETRY_DELAY_MS = 5000;

      const attemptCreateEcomLead = (attempt = 1) => {
        apiCall
          .createecomlead(ecomdbBody, {})
          .then((res) => {
            const protocol = res?.data;
            if (isEcomLeadSuccess(protocol)) {
              // Success - proceed to send emails
              sendEmails();
            } else {
              console.log(
                `Ecom Lead attempt ${attempt} failed - response not successful`,
              );
              if (attempt < MAX_RETRIES) {
                console.log(`Retrying in ${RETRY_DELAY_MS / 1000} seconds...`);
                setTimeout(() => {
                  attemptCreateEcomLead(attempt + 1);
                }, RETRY_DELAY_MS);
              } else {
                // Max retries reached
                setErrorMessage("Something went wrong please try again");
                setShowError(true);
                setIsLoading(false);
              }
            }
          })
          .catch((error) => {
            console.log(`Ecom Lead attempt ${attempt} error:`, error);
            if (attempt < MAX_RETRIES) {
              console.log(`Retrying in ${RETRY_DELAY_MS / 1000} seconds...`);
              setTimeout(() => {
                attemptCreateEcomLead(attempt + 1);
              }, RETRY_DELAY_MS);
            } else {
              // Max retries reached
              setErrorMessage("Something went wrong please retry later.");
              setShowError(true);
              setIsLoading(false);
            }
          });
      };

      // Start the first attempt
      attemptCreateEcomLead(1);
    },
  });

  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      top > header_height && window_width > 1024
        ? document.querySelector("a").classList.add("fixed-header-desktop")
        : document.querySelector("a").classList?.remove("fixed-header-desktop");
    },
    false,
  );
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      top > header_height && window_width > 1024
        ? document.querySelector("nav").classList.add("fixed-header-desktop")
        : document
            .querySelector("nav")
            .classList?.remove("fixed-header-desktop");
    },
    false,
  );

  useEffect(() => {
    let current_page = window.location.href.split("/").at(-1);
    setTimeout(() => {
      document
        .getElementById(`${current_page}`)
        ?.scrollIntoView({ block: "center", behavior: "smooth" });
    }, 100);
  });

  useEffect(() => {
    if (show) {
      modalRef.current.classList?.add(styles.visible);
    } else {
      modalRef.current.classList?.remove(styles.visible);
    }
  }, [show]);
  useEffect(() => {
    if (showSuccess) successModalRef.current?.classList?.add(styles.visible);
    else successModalRef.current?.classList?.remove(styles.visible);
  }, [showSuccess]);

  useEffect(() => {
    if (showError) errorModalRef.current?.classList?.add(styles.visible);
    else errorModalRef.current?.classList?.remove(styles.visible);
  }, [showError]);

  useEffect(() => {
    setIsCitiesLoading(true);
    apiCall
      .getCity()
      .then((res) => {
        const cityarr = res?.data?.responseData?.cities?.map(
          ({ station_code, station_name }) => ({
            value: station_code,
            label: station_name,
          }),
        );
        setCities(cityarr);
      })
      .catch((error) => {
        console.log("===============", error);
      })
      .finally(() => {
        setIsCitiesLoading(false);
      });
  }, []);

  useEffect(() => {
    setArea([]);

    formik.setFieldValue("area", "");

    formik.setFieldTouched("area", false);
    formik.setFieldError("area", undefined);

    if (formik?.values?.city?.value) {
      setIsAreaLoading(true);
      apiCall
        .getAreaCode(formik.values.city.value)
        .then((res) => {
          const areaarr =
            res?.data?.responseData?.data?.map(({ areacode, areaname }) => ({
              value: areaname,
              label: areaname,
            })) || [];

          setArea(areaarr);
        })
        .catch((error) => {
          console.log("Error fetching area:", error);
        })
        .finally(() => {
          setIsAreaLoading(false);
        });
    }
  }, [formik?.values?.city?.value]);

  const handleCnicChange = (event) => {
    const { value, selectionStart } = event.target;
    const isBackspace = event.nativeEvent.inputType === "deleteContentBackward";

    const cleanedValue = value.replace(/[^\d]/g, "");

    const cursorPosition =
      selectionStart -
      (isBackspace && cleanedValue[selectionStart] === "-" ? 1 : 0);

    const formattedCnic =
      cleanedValue.slice(0, 5) +
      (cleanedValue.length > 5 ? "-" + cleanedValue.slice(5, 12) : "") +
      (cleanedValue.length > 12 ? "-" + cleanedValue.slice(12, 13) : "");

    formik.setFieldValue("cnic", formattedCnic, true);

    event.target.setSelectionRange(cursorPosition, cursorPosition);
  };

  useEffect(() => {
    const inputElement = document.getElementById("mobNum");
    const inputElement3 = document.getElementById("compNum");

    const handleInputChange = (event) => {
      const inputValue = event.target.value;
      const maxLength = 11;

      if (inputValue.length > maxLength) {
        event.target.value = inputValue.slice(0, maxLength);
      }

      formik.handleChange(event);
    };

    inputElement.addEventListener("input", handleInputChange);
    inputElement3.addEventListener("input", handleInputChange);

    return () => {
      inputElement.removeEventListener("input", handleInputChange);
      inputElement3.removeEventListener("input", handleInputChange);
    };
  }, [formik]);

  const handleNtnChange = (event) => {
    const { value, selectionStart } = event.target;
    const isBackspace = event.nativeEvent.inputType === "deleteContentBackward";
    const cleanedValue = value.replace(/[^a-zA-Z0-9]/g, "");

    let formatted = cleanedValue.slice(0, 7);
    if (cleanedValue.length > 7) {
      formatted += "-" + cleanedValue.slice(7, 8);
    }
    formik.setFieldValue("ntn", formatted);
    setTimeout(() => {
      if (event.target.setSelectionRange) {
        let cursorPos = selectionStart;
        if (!isBackspace && cleanedValue.length === 7) cursorPos++;
        event.target.setSelectionRange(cursorPos, cursorPos);
      }
    }, 0);
  };

  useEffect(() => {
    const hasError =
      !!formik.errors.compAccTitle ||
      !!formik.errors.ownerName ||
      !!formik.errors.categories ||
      !!formik.errors.ntn ||
      // (!isNonRegistered && !!formik.errors.ntn) ||
      !!formik.errors.city ||
      !!formik.errors.area ||
      !!formik.errors.pickAddress ||
      !!formik.errors.PhoneNo || // Phone validation
      !!formik.errors.billAddress ||
      !!formik.errors.mobNum ||
      !!formik.errors.compEmail ||
      !!formik.errors.designation ||
      !!formik.errors.cnic;

    const allFilled =
      formik.values.compAccTitle &&
      formik.values.ownerName &&
      formik.values.categories &&
      // (isNonRegistered || formik.values.ntn) &&
      formik.values.ntn &&
      formik.values.city &&
      formik.values.area &&
      formik.values.pickAddress &&
      formik.values.billAddress &&
      formik.values.mobNum &&
      formik.values.compEmail &&
      formik.values.designation &&
      formik.values.cnic;

    setNextEnabled(allFilled && !hasError);
  }, [formik.values, formik.errors]);

  return (
    <div>
      <div className="bg-[#efefef] flex flex-col justify-center items-center h-[150px]">
        <h1 className="sm:text-[40px] text-[30px] font-bold">
          E-com Solutions
        </h1>
        <p className="text-[1.05rem] mt-[-5px]">Account Opening Request Form</p>
      </div>
      <div className="mt-[1rem] mb-[1rem]">
        <div className="sm:flex block flex-col justify-center items-center mt-[.5rem] ">
          <div className="flex flex-col gap-1 lg:py-1 px-8 shadow-cards text-sm md:w-[48rem] lg:w-[56rem] sm:w-[40rem] w-[auto] mx-[1rem] rounded-md transition-all duration-500 ">
            <p className="mt-0  text-lg font-bold">Business Information</p>
            <div
              className="grid gap-2 mt-1 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
              id="form1"
            >
              {/* Row 1: Company Name/ Acc. Title  */}
              <div className="MuiFormControl-root MuiTextField-root">
                <div className="relative">
                  <input
                    type="text"
                    id="compAccTitle"
                    className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                    placeholder=" "
                    name="compAccTitle"
                    maxLength={49}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.compAccTitle}
                  />
                  <label
                    htmlFor="compAccTitle"
                    className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >
                    Company Name/ Acc. Title{" "}
                    <span className="text-[red] text-[15px] ml-[-3px]">*</span>
                  </label>
                </div>
                <ErrorText
                  text={
                    formik?.touched?.compAccTitle &&
                    formik?.errors?.compAccTitle
                  }
                />
              </div>

              {/* Row 2: Owner Name | CNIC Number */}

              <div className="MuiFormControl-root MuiTextField-root flex-1">
                <div className="relative">
                  <input
                    type="text"
                    id="ownerName"
                    className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                    placeholder=" "
                    name="ownerName"
                    maxLength={49}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.ownerName}
                  />
                  <label
                    htmlFor="ownerName"
                    className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >
                    Owner Name{" "}
                    <span className="text-[red] text-[15px] ml-[-3px]">*</span>
                  </label>
                </div>
                <ErrorText
                  text={formik?.touched?.ownerName && formik?.errors?.ownerName}
                />
              </div>

              <div className="MuiFormControl-root MuiTextField-root flex-1">
                <div className="relative">
                  <Select
                    className="select1"
                    placeholder="Categories*"
                    name="categories"
                    id="categories"
                    options={categoryOptions}
                    value={categoryOptions.find(
                      (opt) => opt.value === formik.values.categories,
                    )}
                    onChange={(option) => {
                      formik.setFieldValue("categories", option?.value);
                    }}
                    onBlur={() => {
                      formik.setFieldTouched("categories", true);
                    }}
                  />
                </div>

                <ErrorText
                  text={formik.touched.categories && formik.errors.categories}
                />
              </div>

              {/* Row 3: NTN Number | STRN Number */}

              <div className="MuiFormControl-root MuiTextField-root flex-1">
                <div className="relative">
                  <input
                    id="ntn"
                    type="text"
                    className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                    placeholder=" "
                    name="ntn"
                    onChange={handleNtnChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.ntn}
                    // disabled={formik.values.bussinessType === "no"}
                    maxLength={9}
                  />
                  <label
                    htmlFor="ntn"
                    className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >
                    NTN Number
                    {/* {formik.values.salesTax === "registered" && ( */}
                    <span className="text-red-500">*</span>
                    {/* )} */}
                  </label>
                </div>
                <ErrorText text={formik?.touched?.ntn && formik?.errors?.ntn} />
              </div>

              <div className="MuiFormControl-root MuiTextField-root flex-1">
                <div className="relative flex-1">
                  <Select
                    className="select1"
                    placeholder="Sales Tax"
                    name="salesTax"
                    id="salesTax"
                    options={salesTaxOptions}
                    value={salesTaxOptions.find(
                      (opt) => opt.value === formik.values.salesTax,
                    )}
                    onChange={(option) => {
                      formik.setFieldValue("salesTax", option?.value);
                    }}
                    onBlur={() => {
                      formik.setFieldTouched("salesTax", true);
                    }}
                  />

                  <ErrorText
                    text={formik.touched.salesTax && formik.errors.salesTax}
                  />
                </div>
              </div>

              {formik.values.salesTax === "registered" && (
                <div className="MuiFormControl-root MuiTextField-root flex-1">
                  <div className="relative">
                    <input
                      type="text"
                      id="strn"
                      className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                      placeholder=" "
                      name="strn"
                      maxLength={18}
                      onChange={(e) => {
                        let value = e.target.value.replace(
                          /[^a-zA-Z0-9}]/g,
                          "",
                        );
                        if (value.length > 13) value = value.slice(0, 13);
                        let formatted = value;
                        if (value.length > 2)
                          formatted = value.slice(0, 2) + "-" + value.slice(2);
                        if (value.length > 4)
                          formatted =
                            formatted.slice(0, 5) + "-" + formatted.slice(5);
                        if (value.length > 8)
                          formatted =
                            formatted.slice(0, 10) + "-" + formatted.slice(10);
                        if (value.length > 11)
                          formatted =
                            formatted.slice(0, 14) + "-" + formatted.slice(14);
                        if (value.length > 13)
                          formatted =
                            formatted.slice(0, 17) + "-" + formatted.slice(17);
                        formik.setFieldValue("strn", formatted);
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.strn || ""}
                    />
                    <label
                      htmlFor="strn"
                      className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                    >
                      STRN Number
                    </label>
                  </div>
                  <ErrorText
                    text={formik?.touched?.strn && formik?.errors?.strn}
                  />
                </div>
              )}

              <div className="MuiFormControl-root flex-1">
                <div className="relative">
                  <Select
                    className="select1"
                    placeholder="Origin (city)*"
                    name="city"
                    id="city"
                    isLoading={isCitiesLoading}
                    value={formik?.values?.city}
                    options={cities}
                    onChange={(e) => {
                      formik?.setFieldValue("city", e);
                    }}
                    onBlur={(e) => {
                      formik?.setFieldTouched("city", true);
                    }}
                  />
                </div>
                <ErrorText
                  text={formik?.touched?.city && formik?.errors?.city}
                />
              </div>
              <div className="MuiFormControl-root flex-1">
                <div className="relative">
                  <Select
                    className="select1"
                    placeholder="Area"
                    name="area"
                    id="area"
                    isLoading={isAreaLoading}
                    value={formik?.values?.area}
                    options={area}
                    onChange={(e) => {
                      formik?.setFieldValue("area", e);
                    }}
                    onBlur={(e) => {
                      formik?.setFieldTouched("area", true);
                    }}
                  />
                </div>
                <ErrorText
                  text={formik?.touched?.area && formik?.errors?.area}
                />
              </div>

              <div className="MuiFormControl-root MuiTextField-root flex-1">
                <div className="relative">
                  <input
                    type="text"
                    id="pickAddress"
                    className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                    placeholder=" "
                    name="pickAddress"
                    maxLength={69}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.pickAddress}
                  />
                  <label
                    htmlFor="pickAddress"
                    className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >
                    Pickup Address{" "}
                    <span className="text-[red] text-[15px] ml-[-3px]">*</span>
                  </label>
                </div>
                <ErrorText
                  text={
                    formik?.touched?.pickAddress && formik?.errors?.pickAddress
                  }
                />
              </div>

              <div className="MuiFormControl-root MuiTextField-root flex-1">
                <div className="relative">
                  <input
                    type="text"
                    id="billAddress"
                    className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                    placeholder=" "
                    name="billAddress"
                    maxLength={59}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.billAddress}
                  />
                  <label
                    htmlFor="billAddress"
                    className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >
                    Billing Address
                    <span className="text-[red] text-[15px] ">*</span>
                  </label>
                </div>
                <ErrorText
                  text={
                    formik?.touched?.billAddress && formik?.errors?.billAddress
                  }
                />
              </div>

              <div className="MuiFormControl-root MuiTextField-root flex-1">
                <div className="relative">
                  <input
                    type="text"
                    inputMode="numeric"
                    id="compNum"
                    className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                    placeholder=""
                    onKeyDown={(e) => {
                      if (
                        !/^[0-9]$/.test(e.key) &&
                        ![
                          "Backspace",
                          "Delete",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                        ].includes(e.key)
                      ) {
                        e.preventDefault();
                      }
                    }}
                    name="compNum"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.compNum}
                  />
                  <label
                    htmlFor="compNum"
                    className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >
                    Company Ph#{" "}
                  </label>
                </div>
                <ErrorText
                  text={formik?.touched?.compNum && formik?.errors?.compNum}
                />
              </div>
              <div className="MuiFormControl-root MuiTextField-root flex-1">
                <div className="relative">
                  <input
                    type="text"
                    inputMode="numeric"
                    id="mobNum"
                    className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                    placeholder=""
                    name="mobNum"
                    maxLength={11}
                    onKeyDown={(e) => {
                      if (
                        !/^[0-9]$/.test(e.key) &&
                        ![
                          "Backspace",
                          "Delete",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                        ].includes(e.key)
                      ) {
                        e.preventDefault();
                      }
                    }}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.mobNum}
                  />
                  <label
                    htmlFor="mobNum"
                    className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >
                    Mobile No{" "}
                    <span className="text-[red] text-[15px] ml-[-3px]">*</span>
                  </label>
                </div>
                <ErrorText
                  text={formik?.touched?.mobNum && formik?.errors?.mobNum}
                />
              </div>

              <div className="MuiFormControl-root MuiTextField-root flex-1">
                <div className="relative">
                  <input
                    type="text"
                    id="compEmail"
                    className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                    placeholder=" "
                    name="compEmail"
                    maxLength={39}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.compEmail}
                  />
                  <label
                    htmlFor="compEmail"
                    className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >
                    Company Email{" "}
                    <span className="text-[red] text-[15px] ml-[-3px]">*</span>
                  </label>
                </div>
                <ErrorText
                  text={formik?.touched?.compEmail && formik?.errors?.compEmail}
                />
              </div>
            </div>

            <div className="flex flex-col gap-1">
              <p className="mt-0  text-lg font-bold">Contact Person</p>
              <div className="grid gap-2 mt-1 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                <div className="MuiFormControl-root MuiTextField-root flex-1">
                  <div className="relative">
                    <input
                      type="text"
                      id="name"
                      className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                      placeholder=" "
                      name="ownerName"
                      maxLength={49}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.ownerName}
                    />
                    <label
                      htmlFor="name"
                      className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                    >
                      Name
                      <span className="text-[red] text-[15px] ">*</span>
                    </label>
                  </div>
                  <ErrorText
                    text={
                      formik?.touched?.ownerName && formik?.errors?.ownerName
                    }
                  />
                </div>
                <div className="MuiFormControl-root MuiTextField-root flex-1">
                  <div className="relative">
                    <input
                      type="text"
                      inputMode="numeric"
                      id="PhoneNo"
                      className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-black focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                      placeholder=" "
                      name="PhoneNo"
                      maxLength={11}
                      onKeyDown={(e) => {
                        if (
                          !/^[0-9]$/.test(e.key) &&
                          ![
                            "Backspace",
                            "Delete",
                            "ArrowLeft",
                            "ArrowRight",
                            "Tab",
                          ].includes(e.key)
                        ) {
                          e.preventDefault();
                        }
                      }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.PhoneNo}
                    />
                    <label
                      htmlFor="PhoneNo"
                      className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                    >
                      Phone Number
                    </label>
                  </div>
                  <ErrorText
                    text={formik?.touched?.PhoneNo && formik?.errors?.PhoneNo}
                  />
                </div>

                <div className="MuiFormControl-root MuiTextField-root flex-1">
                  <div className="relative">
                    <input
                      type="text"
                      id="designation"
                      className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                      placeholder=" "
                      name="designation"
                      maxLength={49}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.designation}
                    />
                    <label
                      htmlFor="designation"
                      className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                    >
                      Designation
                      <span className="text-[red] text-[15px] ">*</span>
                    </label>
                  </div>
                  <ErrorText
                    text={
                      formik?.touched?.designation &&
                      formik?.errors?.designation
                    }
                  />
                </div>

                <div className="MuiFormControl-root MuiTextField-root flex-1">
                  <div className="relative">
                    <input
                      type="text"
                      id="custCNIC"
                      className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                      placeholder=" "
                      name="cnic"
                      onChange={handleCnicChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.cnic}
                      maxLength={15}
                    />
                    <label
                      htmlFor="custCNIC"
                      className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                    >
                      CNIC
                      <span className="text-[red] text-[15px] ">*</span>
                    </label>
                  </div>
                  <ErrorText
                    text={formik?.touched?.cnic && formik?.errors?.cnic}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="sm:flex block flex-col justify-center items-center mt-[.5rem] ">
        <div className="flex flex-col mx-[1rem]">
          <div className="flex flex-col items-center sm:mx-[3rem] mx-[2rem]">
            <button
              type="button"
              disabled={!nextEnabled || isLoading}
              onClick={() => setOpenTariffModal(true)}
              className={`text-white w-full md:w-[46rem] lg:w-[56rem] sm:w-[39rem] sm:ml-0 rounded-md mt-1 mb-6 p-1 h-[2.5rem] flex items-center justify-center text-sm transition-all duration-500 ${
                !nextEnabled || isLoading
                  ? "bg-gray-400 border-gray-300 cursor-not-allowed opacity-50"
                  : "bg-[#D40511] border-[#F21E26] hover:bg-[#F21E26] hover:text-white"
              }`}
            >
              Next
            </button>
          </div>
        </div>
      </div>
      <BootstrapDialog
        onClose={() => setOpen(false)}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <div className="w-[30rem] pt-2 pb-1 pl-2">
          <h1>Enter Query</h1>
          <div className="flex w-full pt-2 pb-2">
            <div className="relative w-[30rem] ">
              <input
                type="text"
                rows="4rem"
                id="floating_outlined"
                className="row-5 block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                placeholder=" "
              />
              <label
                htmlFor="floating_outlined"
                rows="4"
                className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
              >
                Customer Name/Account Title
              </label>
            </div>
          </div>

          <div className="flex p-[1rem] justify-end ">
            <div className="mr-[1rem]">
              <Button variant="outlined">Text</Button>
            </div>

            <div>
              <Button variant="contained" color="error">
                Submit1
              </Button>
            </div>
          </div>
        </div>
      </BootstrapDialog>{" "}
      <div
        ref={modalRef}
        className={`${styles.modal__wrap}`}
        onClick={() => setShow(false)}
      >
        <div
          className={`flex flex-col justify-center items-center ${styles.modal}`}
        >
          <div className="bg-white w-full h-[106%] relative z-[1000] rounded-3xl">
            <div className="flex justify-center items-center">
              <img
                src="/popup-circle.png"
                alt=""
                className="mx-auto w-[12.5rem]"
              />
              <img
                src="/popup-icon.png"
                alt=""
                className="absolute top-[-3.5rem] mx-auto w-[7rem]"
              />
            </div>

            <div className="flex flex-col text-center justify-center item-center my-[4rem]">
              <h2 className="font-bold text-xl">Thank you for submitting.</h2>
              <p>We'll contact you soon.</p>
            </div>
          </div>
          <div className="mx-auto bg-[#ed1d25] w-[80%] h-[2rem] rounded-full mt-[-1.2rem]"></div>
        </div>
      </div>
      {showError && (
        <div
          ref={errorModalRef}
          className={`${styles.modal__wrap}`}
          onClick={() => setShowError(false)}
        >
          <div
            className={`flex flex-col justify-center items-center ${styles.modal}`}
          >
            <div className="bg-white w-full h-[106%] relative z-[1000] rounded-3xl border-2 border-red-500">
              <div className="flex justify-center items-center">
                <img
                  src="/popup-circle.png"
                  alt=""
                  className="mx-auto w-[12.5rem]"
                />
                {/* <img
                  src="/error.png"
                  alt=""
                  className="absolute top-[-3.5rem] mx-auto w-[7rem]"
                /> */}
              </div>
              <div
                className="absolute right-[1rem] top-[1rem] cursor-pointer"
                onClick={() => setShowError(false)}
              >
                <CloseIcon fontSize="large" style={{ color: "#f21e26" }} />
              </div>
              <div className="flex flex-col text-center justify-center item-center mt-[6rem]">
                <h2 className="font-bold text-[1.5rem] text-red-600">
                  {errorMessage}
                </h2>
              </div>
            </div>
          </div>
        </div>
      )}
      {isLoading && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
          <CircularProgress size={60} sx={{ color: "#D40511" }} />
        </div>
      )}
      <Dialog
        open={showTermsModal}
        onClose={() => setShowTermsModal(false)}
        maxWidth="lg"
        fullWidth
        scroll="paper"
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          {/* <span style={{ fontWeight: "bold", color: "#D40511" }}>
            Terms and Conditions
          </span> */}
          <IconButton
            aria-label="close"
            onClick={() => setShowTermsModal(false)}
            sx={{ color: "#D40511" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <ServiceAgreementForm />
        </DialogContent>
      </Dialog>
      <Dialog
        open={showUndertakingModal}
        onClose={() => setShowUndertakingModal(false)}
        maxWidth="md"
        fullWidth
        scroll="paper"
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={() => setShowUndertakingModal(false)}
            sx={{ color: "#D40511" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Undertaking />
        </DialogContent>
      </Dialog>
      <BootstrapDialog
        open={openTariffModal}
        onClose={() => setOpenTariffModal(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          Rates &amp; Acceptance
          <IconButton
            onClick={() => setOpenTariffModal(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <h2 className="font-bold text-[1.1rem] sm:px-5 px-1">
            {/* Rates &amp; Acceptance */}
          </h2>

          <div className="flex gap-4 sm:px-5 px-1">
            <div className="flex-1 flex flex-col">
              <div className="sm:flex grid gap-[0.1rem]">
                <div className="bg-[#f21e26] text-white rounded-l-md h-[2.5rem] flex-1 flex justify-center items-center">
                  24-48 Hours Delivery{" "}
                </div>
              </div>
              <table className="mt-2 text-[16px]">
                <thead>
                  <tr className="text-left bg-gray-100">
                    <th className="border px-2 py-1">Description</th>
                    <th className="border px-2 py-1">Zones</th>
                    <th className="border px-2 py-1 text-center">0.5 Kg</th>
                    <th className="border px-2 py-1 text-center">
                      1 Kg & Each Add. Kg
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border px-2 py-1">Same City</td>
                    <td className="border px-2 py-1">Same City</td>
                    <td className="border px-2 py-1 text-right">165</td>
                    <td className="border px-2 py-1 text-right">175</td>
                  </tr>
                  <tr>
                    <td className="border px-2 py-1">
                      Within Sindh/Within Punjab, ISB & AJK/Within KPK
                    </td>
                    <td className="border px-2 py-1">Same Zone</td>
                    <td className="border px-2 py-1 text-right">240</td>
                    <td className="border px-2 py-1 text-right">270</td>
                  </tr>
                  <tr>
                    <td className="border px-2 py-1">
                      Within Province Far-flung Remote Locations
                    </td>
                    <td className="border px-2 py-1">Same Zone Ext</td>
                    <td className="border px-2 py-1 text-right">355</td>
                    <td className="border px-2 py-1 text-right">375</td>
                  </tr>
                  <tr>
                    <td className="border px-2 py-1">
                      Province to Province (Punjab, South Punjab, Baluchistan,
                      ISB, AJK & KPK)
                    </td>
                    <td className="border px-2 py-1">Diff Zone</td>
                    <td className="border px-2 py-1 text-right">285</td>
                    <td className="border px-2 py-1 text-right">295</td>
                  </tr>
                  <tr>
                    <td className="border px-2 py-1">
                      Sindh to Punjab, KPK, ISB, AJK, Baluchistan & Vice Versa
                    </td>
                    <td className="border px-2 py-1">Diff Zone 2</td>
                    <td className="border px-2 py-1 text-right">285</td>
                    <td className="border px-2 py-1 text-right">295</td>
                  </tr>
                  <tr>
                    <td className="border px-2 py-1">
                      Sindh to Punjab, KPK, ISB, AJK, Baluchistan Far-flung,
                      Remote Locations & Vice Versa
                    </td>
                    <td className="border px-2 py-1">Diff Zone Ext</td>
                    <td className="border px-2 py-1 text-right">375</td>
                    <td className="border px-2 py-1 text-right">405</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="flex gap-2 mt-2 sm:px-5 pb-2 px-1">
            <div className="flex-1 flex flex-col">
              <div className="sm:flex grid gap-[0.1rem]">
                <div className="bg-[#f21e26] text-white rounded-l-md h-[2.5rem] flex-1 flex justify-center items-center text-[0.8rem]">
                  ECONOMY EXPRESS (48-72 Hrs)
                </div>
                <div className="bg-[#f21e26] text-white rounded-r-md h-[2.5rem] flex-1 flex justify-center items-center">
                  Upto 3 kg
                </div>
                <div className="bg-[#f21e26] text-white rounded-r-md h-[2.5rem] flex-1 flex justify-center items-center">
                  Each Add kg
                </div>
              </div>
              <table className="mt-3">
                <thead>
                  <tr className="text-left bg-gray-100">
                    <th className="border p-2">Nationwide</th>
                    <th className="border p-2 text-right mr-5">450</th>
                    <th className="border p-2 text-right">150</th>
                  </tr>
                </thead>
              </table>
              <p className="text-white bg-[#f21e26] mt-4 p-2 text-center">
                Fuel Adjustment + Sales Tax will be applied on above tariff
              </p>
            </div>
          </div>

          {/* CNIC Upload Section */}
          <div className="sm:px-5 px-1 mt-4 grid sm:grid-cols-2 gap-4">
            {/* Front CNIC */}
            <div className="w-[83%] lg:w-full">
              <label className="block font-semibold mb-2">CNIC Front</label>
              <div className="border-2 border-dashed border-gray-300 rounded-xl p-6 text-center hover:border-red-500 transition-all duration-300 bg-gray-50">
                <input
                  type="file"
                  accept=".jpg,.jpeg,.png"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (!file) return;
                    if (file.size > 1048576) {
                      setNicFrontError("File must be less than 1MB");
                      formik.setFieldValue("nicfront", null);
                      return;
                    }
                    if (!file.type.startsWith("image/")) {
                      setNicFrontError("Only image files are allowed");
                      formik.setFieldValue("nicfront", null);
                      return;
                    }
                    setNicFrontError("");
                    formik.setFieldValue("nicfront", file);
                  }}
                  className="hidden"
                  id="cnicFrontUpload"
                />
                <label
                  htmlFor="cnicFrontUpload"
                  className="cursor-pointer flex flex-col items-center justify-center gap-2"
                >
                  <div className="bg-red-100 p-3 rounded-full">📤</div>
                  <p className="text-gray-700 font-medium">Click to upload</p>
                  <p className="text-xs text-gray-500">
                    JPG, PNG, JPEG (Max 1MB)
                  </p>
                </label>
              </div>
              {nicFrontError && (
                <p className="text-red-600 text-sm mt-1">{nicFrontError}</p>
              )}
              {formik.values.nicfront && (
                <div className="mt-3 flex justify-between items-center bg-white border rounded-lg px-3 py-2 shadow-sm">
                  <span className="text-[13px] truncate">
                    {formik.values.nicfront.name}
                  </span>
                  <div className="flex gap-2">
                    <a
                      href={URL.createObjectURL(formik.values.nicfront)}
                      download={formik.values.nicfront.name}
                      className="text-blue-500 text-xs hover:underline"
                    >
                      Download
                    </a>
                    <button
                      type="button"
                      onClick={() => {
                        formik.setFieldValue("nicfront", null);
                        setNicFrontError("");
                      }}
                      className="text-red-500 text-xs hover:underline"
                    >
                      Remove
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* Back CNIC */}
            <div className="w-[83%] lg:w-full">
              <label className="block font-semibold mb-2">CNIC Back</label>
              <div className="border-2 border-dashed border-gray-300 rounded-xl p-6 text-center hover:border-red-500 transition-all duration-300 bg-gray-50">
                <input
                  type="file"
                  accept=".jpg,.jpeg,.png"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (!file) return;
                    if (file.size > 1048576) {
                      setNicBackError("File must be less than 1MB");
                      formik.setFieldValue("nicback", null);
                      return;
                    }
                    if (!file.type.startsWith("image/")) {
                      setNicBackError("Only image files are allowed");
                      formik.setFieldValue("nicback", null);
                      return;
                    }
                    setNicBackError("");
                    formik.setFieldValue("nicback", file);
                  }}
                  className="hidden"
                  id="nicbackUpload"
                />
                <label
                  htmlFor="nicbackUpload"
                  className="cursor-pointer flex flex-col items-center justify-center gap-2"
                >
                  <div className="bg-red-100 p-3 rounded-full">📤</div>
                  <p className="text-gray-700 font-medium">Click to upload</p>
                  <p className="text-xs text-gray-500">
                    JPG, PNG, JPEG (Max 1MB)
                  </p>
                </label>
              </div>
              {nicBackError && (
                <p className="text-red-600 text-sm mt-1">{nicBackError}</p>
              )}
              {formik.values.nicback && (
                <div className="mt-3 flex justify-between items-center bg-white border rounded-lg px-3 py-2 shadow-sm">
                  <span className="text-[13px] truncate">
                    {formik.values.nicback.name}
                  </span>
                  <div className="flex gap-2">
                    <a
                      href={URL.createObjectURL(formik.values.nicback)}
                      download={formik.values.nicback.name}
                      className="text-blue-500 text-xs hover:underline"
                    >
                      Download
                    </a>
                    <button
                      type="button"
                      onClick={() => {
                        formik.setFieldValue("nicback", null);
                        setNicBackError("");
                      }}
                      className="text-red-500 text-xs hover:underline"
                    >
                      Remove
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="sm:flex block flex-col justify-center items-center mt-[.7rem] ">
            <div className="sm:flex block flex-col justify-center items-center mt-[.5rem] w-[100%] px-[1rem]">
              <div className="flex flex-col gap-3 px-7  pt-2 pb-1 shadow-cards text-sm  md:w-[100%] lg:w-[50rem] sm:w-[33rem] w-[auto] mx-[rem] rounded-md transition-all duration-500">
                <h2 className="font-bold text-[1.1rem]">
                  Terms &amp; Conditions
                </h2>
                <div className="flex gap-4">
                  <div className="flex-1 flex flex-col">
                    <div className="MuiFormGroup-root">
                      <div className="flex items-center mr-4 h-[27px]">
                        <FormControlLabel
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          checked={formik.values.termCond}
                          name="termCond"
                          control={
                            <Checkbox
                              sx={{ "&.Mui-checked": { color: red[600] } }}
                            />
                          }
                          label={
                            <p className="text-sm">
                              I have read and hereby accept the{" "}
                              <span
                                onClick={(e) => {
                                  e.preventDefault();
                                  setShowTermsModal(true);
                                }}
                                className="text-[#337ab7] cursor-pointer hover:underline"
                              >
                                Terms and Conditions
                              </span>
                            </p>
                          }
                        />
                      </div>
                      <ErrorText
                        text={
                          formik?.touched?.termCond && formik?.errors?.termCond
                        }
                      />

                      <div className="flex items-center mt-0 h-[27px]">
                        <FormControlLabel
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          checked={formik.values.undertak}
                          name="undertak"
                          control={
                            <Checkbox
                              sx={{ "&.Mui-checked": { color: red[600] } }}
                            />
                          }
                          label={
                            <p className="text-sm">
                              I have read and hereby accept the{" "}
                              <span
                                onClick={(e) => {
                                  e.preventDefault();
                                  setShowUndertakingModal(true);
                                }}
                                className="text-[#337ab7] cursor-pointer hover:underline"
                              >
                                Undertaking
                              </span>
                            </p>
                          }
                        />
                      </div>
                      <ErrorText
                        text={
                          formik?.touched?.undertak && formik?.errors?.undertak
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col justify-center  mt-[1rem] ">
            <div className="flex gap-4 md:w-[40rem] sm:w-[33rem] w-[auto] mx-[1rem] ">
              <div className="g-recaptcha">
                <ReCAPTCHA
                  sitekey={process.env.REACT_APP_CAPTCH}
                  onChange={(value) => formik.setFieldValue("recaptcha", value)}
                />
              </div>
            </div>
          </div>
        </DialogContent>

        <div className="flex justify-center py-4 px-6">
          <Button
            variant="contained"
            color="error"
            className="text-white w-full md:w-[48rem] lg:w-[56rem] sm:w-[40rem] "
            onClick={async () => {
              await formik.handleSubmit();
              setOpenTariffModal(false);
            }}
            disabled={!formik.isValid || isLoading || formik.isSubmitting}
          >
            {isLoading || formik.isSubmitting ? (
              <CircularProgress size={20} />
            ) : (
              "Submit"
            )}
          </Button>
        </div>
      </BootstrapDialog>
    </div>
  );
};

export default TcsEcom;
